import { get } from "lodash";
import { AppState } from "../index";

export const getMainNavigationCopy = (store: AppState) => {
  return get(store, "clientConfigs.data.mainNavigation.properties.copy");
};
